import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { BffService } from '../../services/BffService';
import { PageHeaderComponent } from '../page-header/page-header.component';

@Component({
  selector: 'app-login-selection',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    PageHeaderComponent,
  ],
  templateUrl: './login-selection.component.html',
  styleUrl: './login-selection.component.css',
})
export class LoginSelectionComponent {
  constructor(private router: Router, private bff: BffService) {}

  navigateToCustomerLogin(): void { this.bff.signInCustomer(); }
  navigateToEmployeeLogin(): void { this.bff.signInEmployee(); }
}
